import { type PlatformApi, type Tokens } from "./types";
import {
  type PaymentProviderType,
  type PaymentProvider,
  type BnplPaymentProvider,
  type StandardPaymentProvider,
} from "../payments/types";
import { bnplPaymentProvider } from "../payments/bnplPaymentProvider";
import { sandboxPaymentProvider } from "../payments/sandboxPaymentProvider";

class WebApi implements PlatformApi {
  getLocale() {
    return new Promise<string>((resolve) => {
      setTimeout(
        () => {
          resolve(import.meta.env.VITE_PUBLIC_DEV_LOCALE!);
        },
        Math.random() * 100 + 50, // random delay between 50ms and 150ms to simulate network request
      );
    });
  }

  setNavigationBar() {
    // web doesn't have a navigation bar
  }

  async signIn() {
    return new Promise<Tokens>((resolve) => {
      setTimeout(
        () => {
          resolve({
            accessToken: import.meta.env.VITE_PUBLIC_DEV_ACCESS_TOKEN!,
            refreshToken: import.meta.env.VITE_PUBLIC_DEV_REFRESH_TOKEN!,
          });
        },
        Math.random() * 1000 + 500, // random delay between 500ms and 1500ms to simulate network request
      );
    });
  }

  async updatePersonalData() {
    return new Promise<void>((resolve) => {
      setTimeout(
        () => {
          // no actual update on web
          resolve();
        },
        Math.random() * 1000 + 500, // random delay between 500ms and 1500ms to simulate network request
      );
    });
  }

  getPaymentProvider(providerType: "bnpl"): BnplPaymentProvider;
  getPaymentProvider(providerType: "standard"): StandardPaymentProvider;
  getPaymentProvider(providerType: PaymentProviderType): PaymentProvider {
    switch (providerType) {
      case "bnpl":
        return bnplPaymentProvider;
      case "standard":
        return sandboxPaymentProvider;
      default:
        throw new Error("Unsupported payment provider type");
    }
  }

  async getEligibilityPayload(cardNumber?: string) {
    // Web platform always uses card numbers
    return Promise.resolve({ cardNumber: cardNumber || "6330153657143355" });
  }
}

export const webApi: PlatformApi = new WebApi();
